import useLenis from "@/hooks/useLenis";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import ImpactStats from "@/components/site/ImpactStats";
import TrustBadges from "@/components/site/TrustBadges";
import About from "@/components/site/About";
import IntroVideo from "@/components/site/IntroVideo";
import Services from "@/components/site/Services";
import Achievements from "@/components/site/Achievements";
import WhyUs from "@/components/site/WhyUs";
import Sectors from "@/components/site/Sectors";
import WorkStages from "@/components/site/WorkStages";
import Projects from "@/components/site/Projects";
import Team from "@/components/site/Team";
import Testimonials from "@/components/site/Testimonials";
import VideoTestimonials from "@/components/site/VideoTestimonials";
import Partners from "@/components/site/Partners";
import FAQ from "@/components/site/FAQ";
import Contact from "@/components/site/Contact";
import LocationMap from "@/components/site/LocationMap";
import Footer from "@/components/site/Footer";
import Chatbot from "@/components/site/Chatbot";
import WhatsAppButton from "@/components/site/WhatsAppButton";
import CookieConsent from "@/components/site/CookieConsent";
import Timeline from "@/components/site/Timeline";
import StickyContactBar from "@/components/site/StickyContactBar";
import QuoteCalculator from "@/components/site/QuoteCalculator";
import BookingCalendar from "@/components/site/BookingCalendar";
import Pricing from "@/components/site/Pricing";
import SectorExplorer from "@/components/site/SectorExplorer";
import SupportTickets from "@/components/site/SupportTickets";
import Seo from "@/components/site/Seo";

export default function Home() {
  useLenis();
  return (
    <div className="App relative" data-testid="home-page">
      <Seo />
      <Header />
      <main>
        <Hero />
        <ImpactStats />
        <TrustBadges />
        <About />
        <IntroVideo />
        <Services />
        <Achievements />
        <Timeline />
        <WhyUs />
        <Sectors />
        <SectorExplorer />
        <WorkStages />
        <Projects />
        <QuoteCalculator />
        <Pricing />
        <BookingCalendar />
        <Team />
        <VideoTestimonials />
        <Testimonials />
        <Partners />
        <FAQ />
        <LocationMap />
        <Contact />
        <SupportTickets />
      </main>
      <Footer />
      <Chatbot />
      <WhatsAppButton />
      <StickyContactBar />
      <CookieConsent />
    </div>
  );
}
